import React, { useState, useEffect } from 'react'
import { createSelector } from 'reselect'
import { parseSearchString } from 'lib/url/searchUrlUtils'
import { connect } from 'react-redux'
import { initialState } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import { getFlightsRecentSearch, mapAirportToAirportLocation } from 'lib/flights/flightUtils'
import FlightsSearchWidget, { FlightSearchWidgetSearchData, StandaloneFlightMenu } from 'components/Flights/FlightsSearch/SearchWidget/FlightSearchWidget'
import { FlightDropdownOption } from '../types'
import { fareCabins, fareTypes, FlightsClassTypes } from 'constants/flight'
import uuidV4 from 'lib/string/uuidV4Utils'
import { useAppSelector } from 'hooks/reduxHooks'
import { isMultiCityEnabled } from 'selectors/flightsSelectors'

interface Props {
  departureAirport?: App.AirportLocation;
  arrivalAirport?: App.AirportLocation;
  flightsCredit?: boolean;
  occupants?: App.Occupants;
  flightDealId?: string;
  fareCabin?: FlightDropdownOption<FlightsClassTypes>;
  fareType?: FlightDropdownOption;
  fromFlightsLanding?: boolean;
}

function FlightsSearch(props: Props) {
  const { departureAirport, arrivalAirport, occupants, flightDealId, fareCabin, fareType, fromFlightsLanding } = props
  const [searchData, setSearchData] = useState<FlightSearchWidgetSearchData>(initialState)
  const multiCityEnabled = useAppSelector(isMultiCityEnabled)

  useEffect(() => {
    setSearchData(searchData => ({
      ...searchData,
      fareCabin,
      fareType,
      flights: [{
        id: uuidV4(),
        departureAirport,
        arrivalAirport,
      }],
      occupants,
      activeMenu: flightDealId ? StandaloneFlightMenu.date : undefined,
      lastSearch: getFlightsRecentSearch(),
      flightDealId,
      showSegmentActiveDeals: fromFlightsLanding,
    }))
  }, [departureAirport, arrivalAirport, occupants, flightDealId, fareCabin, fareType, fromFlightsLanding])

  return <FlightsSearchWidget searchData={searchData} showMultiCity={multiCityEnabled} />
}

const getSearchValues = createSelector(
  (state: App.State) => state.router.location.search,
  (state: App.State) => state.geo.airports,
  (search, airports) => {
    const { origin, destination, adults, children, flightDeal: flightDealId, fareClass, fareType } = parseSearchString(search)
    const departure = airports.find(airport => airport.code.toLowerCase() === origin?.toLowerCase())
    const arrival = airports.find(airport => airport.code.toLowerCase() === destination?.toLowerCase())
    const childrenCount = parseInt(children) || 0

    const occupants = {
      adults: parseInt(adults) || 1,
      children: childrenCount,
      childrenAge: Array(childrenCount).fill(-1),
    }

    return {
      departureAirport: departure ? mapAirportToAirportLocation(departure) : null,
      arrivalAirport: arrival ? mapAirportToAirportLocation(arrival) : null,
      occupants,
      flightDealId,
      fareCabin: fareCabins.find(type => type.value === fareClass) ?? fareCabins[0],
      fareType: fareTypes.find(type => type.value === fareType) ?? fareTypes[0],
    }
  },
)

function mapStateToProps(state: App.State) {
  return {
    ...getSearchValues(state),
  }
}

export default connect(mapStateToProps)(FlightsSearch)
